// extracted by mini-css-extract-plugin
export default {"wrapper":"wz-z","viewport":"xz-z","container":"yz-z","slide":"zz-z"};